
import ResultCardModalComponent from "@/components/Modals/ResultCardModal/ResultCardModalComponent";
export default ResultCardModalComponent;
